@if (resAsync | async) {
  <div class="root-container profile-selection-container" fxLayout="row" fxLayoutAlign="center center">
    @if (
      {
        loginInfo: (loginInfo$ | async),
        isLoadingProfiles: (isLoadingProfiles$ | async),
        profiles: (profiles$ | async),
      };
      as observables
    ) {
      <div class="frame-container" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="80%" fxFlex.md="95%">
        <br />
        <div
          class="flex-container"
          fxFlex="50%"
          fxFlex.xs="100%"
          fxFlex.lt-sm="95%"
          fxFlex.sm="80%"
          fxFlex.md="95%"
          fxFlex.lg="90%"
          fxFlex.gt-lg="90%"
          fxFlex.lt-xl="90%"
        >
          @if (
            {
              loginInfo: (loginInfo$ | async),
              isLoadingProfiles: (isLoadingProfiles$ | async),
              profiles: (profiles$ | async),
            };
            as observables
          ) {
            <div class="left">
              <div fxLayout="row" fxLayoutAlign="start center" style="height: 40px; padding-right: 20px">
                <div>
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon [svgIcon]="res.svgName('ProfileSelectionUser-Image')" class="profileIcon"></mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button
                      mat-menu-item
                      [disabled]="observables.isLoadingProfiles || isApplyingProfile"
                      (click)="logout($event.ctrlKey || $event.metaKey)"
                    >
                      {{ res.get('ProfileSelection-Logout') }}
                    </button>
                  </mat-menu>
                </div>
                <div style="padding-left: 10px">
                  @if (observables.loginInfo && !observables.loginInfo.isPublicAccess) {
                    <div class="titleText">
                      {{ observables.loginInfo.displayName }}
                    </div>
                  }
                </div>
              </div>
              <br />
              <div class="profile-container">
                @if (!observables.isLoadingProfiles && !isApplyingProfile && !errorMessage && observables.profiles) {
                  @if (observables.profiles.length) {
                    <div fxLayout="row" fxLayoutAlign="center none" class="leftHeaderText">
                      <label>{{ res.get('ProfileSelection-SelectProfile') }}</label>
                    </div>
                    <br />
                    <dx-list
                      class="list"
                      [dataSource]="profilesDataSource"
                      [searchEnabled]="true"
                      [searchEditorOptions]="{ placeholder: this.res.get('Search') }"
                      [displayExpr]="'displayText'"
                      [searchExpr]="'displayText'"
                      selectionMode="single"
                      [showSelectionControls]="false"
                      (onSelectionChanged)="listSelectionChanged($event)"
                      [selectedItemKeys]="[selectedProfile.displayText]"
                      noDataText=""
                      pageLoadMode="scrollBottom"
                    >
                      <div *dxTemplate="let item of 'item'">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          <div class="itemDisplay">{{ item.displayText }}</div>
                          <dx-button
                            class="buttonTest"
                            [text]="this.res.get('ProfileSelection-Choose')"
                            type="normal"
                            [width]="90"
                            [disabled]="
                              observables.isLoadingProfiles ||
                              isApplyingProfile ||
                              profilesDataSource == null ||
                              observables.profiles.length == 0
                            "
                            (click)="selectProfileAndApply(item)"
                          ></dx-button>
                        </div>
                      </div>
                    </dx-list>
                  } @else {
                    <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
                      <div class="waring">
                        <mat-icon class="iconError" [svgIcon]="res.svgName('Warning-Image')"></mat-icon>
                      </div>
                      <div class="descriptionError">
                        <span>{{ res.get('ProfileSelection-NoProfile-Message-1') }} </span>
                        <span>{{ res.get('ProfileSelection-NoProfile-Message-2') }}</span>
                      </div>
                    </div>
                  }
                } @else {
                  @if (!isApplyingProfile && !errorMessage) {
                    <ng-container
                      *ngTemplateOutlet="
                        progressTemplate;
                        context: getProgressTemplateContext(this.res.get('ProfileSelection-ApplyProgress'))
                      "
                    >
                    </ng-container>
                  }
                }
                @if (isApplyingProfile && !errorMessage) {
                  @if (!errorMessage) {
                    <ng-container
                      *ngTemplateOutlet="
                        progressTemplate;
                        context: getProgressTemplateContext(this.res.get('ProfileSelection-ApplySuccess'))
                      "
                    >
                    </ng-container>
                  }
                }
              </div>
            </div>
          }
          <div class="right">
            @if (selectedProfile.displayText) {
              <div class="header">
                <div class="name-container">
                  <div class="name">{{ selectedProfile.displayText }}</div>
                  <div class="name" style="font-size: small"></div>
                  <mat-form-field class="form-Container" style="width: 585px; height: 65px">
                    <textarea
                      style="
                        height: 35px;
                        font-size: 12px;
                        resize: none;
                        letter-spacing: 0;
                        line-height: 1.5;
                        width: 85%;
                      "
                      disabled
                      matInput
                      >{{ selectedProfile.description }}</textarea
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="imageContainer">
                <img
                  class="previewImage"
                  [src]="
                    selectedProfile.mapImagePreview
                      ? 'data:image/png;base64,' + selectedProfile.mapImagePreview
                      : 'assets/resources/basys-core-authentication/images/image_profiles_1.png'
                  "
                />
              </div>
              <!-- </div> -->
            }
            @if (!observables.isLoadingProfiles && !isApplyingProfile && !errorMessage && observables.profiles) {
              @if (observables.profiles.length === 0) {
                <div class="errcontainer">
                  <div class="err">
                    <span> {{ res.get('ProfileSelection-NoProfileFound') }} </span>
                  </div>
                </div>
              }
            } @else {
              @if (!isApplyingProfile && !errorMessage) {
                <ng-container *ngTemplateOutlet="progressTemplate; context: getProgressTemplateContext('')">
                </ng-container>
              }
            }
          </div>
          <ng-template #progressTemplate let-message="message">
            <div class="loaderClass dark {{ errorClass ? ' ' + errorClass : '' }}">
              <div class="msgStyle dark">{{ message }}</div>
              <abcLoader
                [id]="'loaderProfiles'"
                [class]="'loader'"
                [show]="true"
                [percentageValue]="false"
                [mode]="'indeterminate'"
              >
              </abcLoader>
            </div>
          </ng-template>
        </div>
      </div>
    }
  </div>
}
